import * as CryptoJS from 'crypto-js';
import { environment } from '@env';

export function encryptData(data: any): string {
  try {

    const dataStr = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(dataStr, environment.STORAGE_SECRET_KEY).toString();
    return encrypted;

  } catch (error) {
    console.error('Encryption error:', error);
    throw error; 
  }
  
}

export function decryptData(encrypted: string): any {
  try {

    if (encrypted.startsWith('{') && encrypted.endsWith('}')) {
      return JSON.parse(encrypted);
    }
    
    const bytes = CryptoJS.AES.decrypt(encrypted, environment.STORAGE_SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    
    if (!decryptedText) {
      throw new Error('Decryption failed - empty result');
    }
    
    return JSON.parse(decryptedText);
  } catch (error) {
    console.error('Decryption error:', error);
    return null;
  }
}